export default __webpack_public_path__ + "static/media/SportSee.3d48081f.svg";